window.onload = (event) => {
  const checkBCPelement = setInterval(()=>{
    const bcpElement = document.querySelector('.bss-b2b-customer-portal-wrapper') 
      if (bcpElement) {
        const bcpNavigate = bcpElement.querySelector('.bss-layout-sidebar-wrapper-hide')
          if (bcpNavigate) {
            const parentBCPelement = bcpNavigate.querySelector(".Polaris-Navigation__PrimaryNavigation.Polaris-Scrollable.Polaris-Scrollable--vertical.Polaris-Scrollable--horizontal")
            if (parentBCPelement) {
              var ulElement = document.createElement("ul");
              ulElement.setAttribute("class", "Polaris-Navigation__Section");
              ulElement.innerHTML = 
                `<li class='Polaris-Navigation__ListItem'>
                  <div class="Polaris-Navigation__ItemWrapper">
                      <div class="Polaris-Navigation__ItemInnerWrapper">
                          <a type="button" class="Polaris-Navigation__Item" href="/account/logout">
                            <div class="Polaris-Navigation__Icon">
                              <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" fill="none" viewBox="0 0 18 19">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M6 4.5a3 3 0 116 0 3 3 0 01-6 0zm3-4a4 4 0 100 8 4 4 0 000-8zm5.58 12.15c1.12.82 1.83 2.24 1.91 4.85H1.51c.08-2.6.79-4.03 1.9-4.85C4.66 11.75 6.5 11.5 9 11.5s4.35.26 5.58 1.15zM9 10.5c-2.5 0-4.65.24-6.17 1.35C1.27 12.98.5 14.93.5 18v.5h17V18c0-3.07-.77-5.02-2.33-6.15-1.52-1.1-3.67-1.35-6.17-1.35z" fill="currentColor">
                                </path>
                              </svg>
                            </div>
                            <span class="Polaris-Navigation__Text">Log out</span>
                          </a>
                      </div>
                  </div>
                </li>`
              parentBCPelement.appendChild(ulElement)
              // parentBCPelement.innerHTML = customLogoutButton
              clearInterval(checkBCPelement);
            }
          }
      }
  }, 1000);

 
};